import { OrderDTO } from 'models/order';

export default function openOrderDetails(push) {
  return (order: OrderDTO) => {
    const { quote: { id }, orderNum } = order;
    push(`quote/${id}`, { quotePage: { orderNum } });
  };
}
